import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import MuiTableCell from '@material-ui/core/TableCell';
import styled from 'src/ui/library/styled';

const styles = theme => ({
  root: {
    height: '74px',
    border: 'none',
    width: '24px',
    padding: '4px 8px 4px 24px',
    fontSize: '12px',
    borderBottom: `solid 1px ${theme.colors.eyGrey3}`,
    '& .content-parser-row': {
      marginBottom: '0px',
    },
  },
  circleRoot: {
    display: 'flex',
    alignItems: 'center',
  },
  circle: {
    display: 'flex',
    alignItems: 'center',
    width: '1.3rem',
    height: '1.3rem',
    backgroundColor: theme.colors.white,
    borderRadius: '50% !important',
    verticalAlign: 'middle',
    border: `1px solid #C4C4CD`,
    '-webkit-appearance': 'none',
    outline: 'none',
    cursor: 'pointer',
  },
  checkbox: {
    display: 'none',
  },
  checked: {
    backgroundColor: theme.colors.eyConfidentGrey,
    '&:before': {
      content: '"\\2713"',
      color: theme.colors.white,
      fontSize: '1.1rem',
      position: 'relative',
      top: '-1px',
      left: '2px',
    },
  },
});

class TableSelectBodyCell extends React.Component {
  static propTypes = {
    /** Row index value */
    rowIndex: PropTypes.number,
    /** Column index value */
    colIndex: PropTypes.number,
    /** Callback function for to handle row selection */
    onRowSelect: PropTypes.func.isRequired,
    /** Callback reference to the internal setState */
    setUpdateSelectCell: PropTypes.func.isRequired,
    /** Styles to be applied to component */
    classes: PropTypes.object,
  };

  handleClick = () => {
    const { rowIndex, rowData, onRowSelect } = this.props;
    onRowSelect({ origRowIndex: rowData[0].origRowIndex, rowIndex });
  };

  updateCellRef = () => {
    this.setState({ updateCell: true });
  };

  render() {
    const { classes, rowData, rowIndex, setUpdateSelectCell } = this.props;

    setUpdateSelectCell(rowIndex, this.updateCellRef);

    const circleClass = classNames({
      [classes.circle]: true,
      [classes.checked]: rowData[0].isRowSelected,
    });
    const checkboxClass = classNames({
      [classes.checkbox]: true,
    });

    return (
      <MuiTableCell className={classes.root}>
        <div className={classes.circleRoot}>
          <input type="checkbox" className={checkboxClass} checked={rowData[0].isRowSelected} onChange={this.handleClick} />
          <label htmlFor={checkboxClass} className={circleClass} onClick={this.handleClick} />
        </div>
      </MuiTableCell>
    );
  }
}

export default styled(TableSelectBodyCell)(styles);
